import React, { createContext, useContext, useState, useEffect } from 'react';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

const ThemeContext = createContext();

export const useThemeMode = () => {  // Renamed from useTheme
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useThemeMode must be used within CustomThemeProvider');
  }
  return context;
};

export const CustomThemeProvider = ({ children }) => {  // Renamed from ThemeProvider
  const [mode, setMode] = useState(() => {
    const savedTheme = localStorage.getItem('themeMode');
    return savedTheme || 'light';
  });

  useEffect(() => {
    localStorage.setItem('themeMode', mode);
  }, [mode]);

  const toggleTheme = () => {
    setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
  };

  const theme = createTheme({
    palette: {
      mode,
      ...(mode === 'light'
        ? {
            primary: {
              main: '#667eea',
            },
            secondary: {
              main: '#764ba2',
            },
            background: {
              default: '#f8f9ff',
              paper: '#ffffff',
            },
            text: {
              primary: '#3c4043',
              secondary: '#6b7280',
            },
          }
        : {
            primary: {
              main: '#818cf8',
            },
            secondary: {
              main: '#9333ea',
            },
            background: {
              default: '#0f172a',
              paper: '#1e293b',
            },
            text: {
              primary: '#f1f5f9',
              secondary: '#cbd5e1',
            },
          }),
    },
    components: {
      MuiDrawer: {
        styleOverrides: {
          paper: {
            background: mode === 'light' 
              ? 'linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%)'
              : 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
          },
        },
      },
    },
  });

  return (
    <ThemeContext.Provider value={{ mode, toggleTheme }}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
};